import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { Badge } from '../../../components/ui/Badge';
import { BADGE_VARIANTS } from '../../../components/ui/badgeVariants';
import type { ContractStatus } from '../utils/contractStatus';
import { CONTRACT_STATUS_VARIANT } from '../utils/contractStatusVariant';

/**
 * Renders a current-contract {@link ContractStatus} as a themed icon + label badge.
 * Colours come from `BADGE_VARIANTS`; the icon inherits the badge font size so no
 * dimension is hardcoded. Label weight matches the instance key-status badges
 * (`fontWeightSemiBold`). Icon + label (not colour alone) carry the meaning.
 */
export function ContractStatusBadge({ status }: { status: ContractStatus }) {
  const { t } = useTranslation('common');
  const theme = useTheme();
  const { variant, icon: Icon, labelKey } = CONTRACT_STATUS_VARIANT[status];
  const colors = BADGE_VARIANTS[variant];

  return (
    <Badge
      color={colors.color}
      bgcolor={colors.bgcolor}
      fontWeight={theme.typography.fontWeightSemiBold}
    >
      <Icon aria-hidden sx={{ fontSize: 'inherit', mr: 0.5 }} />
      {t(labelKey)}
    </Badge>
  );
}
